import * as types from './constants'

export function setLocale(locale) {
    return {
        type: types.SET_LOCALE,
        data: {
            locale,
        },
    }
}
